import qs from 'qs'

const fields = [
  'datePosted',
  'locale',
  'source',
  'sourceUrl',
  'title',
]

const sort = ['datePosted:desc']

const populate = {
  ...queryFragmentExhibitionEntry,
  files: true,
}

export const queryPressEntriesThumbnail = (options: QueryManyOptionsi18n) => {
  const query = qs.stringify(
    {
      locale: options?.locale || 'nl-NL',
      pagination: {
        page: options?.page || 1,
        pageSize: options?.pageSize || 20
      },
      sort: sort,
      fields: fields,
      populate: {
        ...populate,
        localizations: {
          fields: fields,
          populate: populate
        },
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `press-entries?${query}`
}
